export interface FfpError {
    "fehler_id": string
}

export interface VirusInfectionError {
    "virusInfected": boolean
}


export function isFfpError(err: any): err is FfpError {
    return !!err?.fehler_id?.startsWith('FFP_');
}

export function isVirusInfectedError(err: any): err is VirusInfectionError {
    return !!err?.virusInfected;
}

